import { format, setMilliseconds, setMinutes, setSeconds } from 'date-fns'
import { useState } from 'react'
import { useOrganizationsAPI } from 'src/API/central.organizationAPI'
import { useUsersTaskAPI } from 'src/API/central.usersTaskAPI'
import { InputStandard } from 'src/components/standard.input'
import { MultiselectStandard } from 'src/components/standard.multiselect'
import { SelectStandard } from 'src/components/standard.select'
import { TablePlater } from 'src/components/standard.table'
import { TypographyLead, TypographyStandardP1, TypographyStandardTitleH2 } from 'src/components/typography'
import { stringToColor } from 'src/lib/utils'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from 'src/shadcn/ui/accordion'
import { ProjectComponentTaskVarient } from './component.projectCard'
import { useNavigate } from 'react-router-dom'
// import { ImportExcelModal } from './component.importExcelModal'



function getLast30MinuteTime(date: Date): string {
    let minutes = date.getMinutes();
    return format(date, 'HH:mm');
    let roundedMinutes = minutes < 30 ? 0 : 30;
    
    // Set time to the last 30-minute mark, resetting seconds & milliseconds
    let roundedDate = setMinutes(date, roundedMinutes);
    roundedDate = setSeconds(roundedDate, 0);
    roundedDate = setMilliseconds(roundedDate, 0);

    return format(roundedDate, 'HH:mm');
}



export function TasksPage() {
    const navigate = useNavigate()
    const { listOrganizations } = useOrganizationsAPI()

    
    const organizations = listOrganizations()
    const [filters, setFilters] = useState<{
        organizationIds?: string[],
        status?: 'completed' | 'inProgress' | 'all',
        sortBy?: 'uncompletedFirst' | 'completedFirst' | 'sortByName',
        date: string,
        time: string
    }>({
        organizationIds: organizations.map(organization => organization.accountId),
        status: 'all',
        sortBy: 'completedFirst',
        date: format(new Date(), 'yyyy-MM-dd'),
        time: getLast30MinuteTime(new Date())
    })

    const {
        users,
        isLoading,
        error
    } = useUsersTaskAPI({
        trigger: filters.date?true:false,
        retryCount: 1,
        ASOF:`${filters.date} ${filters.time?filters.time:'00:00'}`
    })

    // Helper function to determine project status based on tasks
  const getProjectStatus = (project: any) => {
    return project.tasks && project.tasks.length > 0 ? 'inProgress' : 'completed';
  };

  const sortedUsers = users?.sort((a, b) => {
    const aProjectTasks = a.projects.reduce((total, project) => total + project.tasks.length, 0);
    const bProjectTasks = b.projects.reduce((total, project) => total + project.tasks.length, 0);
    if (filters.sortBy === 'completedFirst') {
      return aProjectTasks - bProjectTasks;
    }else if(filters.sortBy === 'uncompletedFirst'){
      return bProjectTasks - aProjectTasks;
    }else{
        const aname = a.user.displayName.toLowerCase();
        const bname = b.user.displayName.toLowerCase();
        return aname.localeCompare(bname);
    }
  });

  // Filter and sort users and their projects
  const filteredUsers = sortedUsers?.map((user) => {
    // Filter projects based on organizationIds
    let filteredProjects = user.projects.filter((project) =>
      filters.organizationIds?.includes(project.organizationId)
    );

    // Apply status filter
    filteredProjects = filteredProjects.filter((project) => {
      const projectStatus = getProjectStatus(project);
      if (filters.status === 'all') return true;
      return projectStatus === filters.status;
    });

    // Sort projects based on sortBy filter
    filteredProjects.sort((a, b) => {
      if (filters.sortBy === 'sortByName') {
        return a.name.localeCompare(b.name);
      }
      
      const aStatus = getProjectStatus(a) === 'completed' ? 1 : 0;
      const bStatus = getProjectStatus(b) === 'completed' ? 1 : 0;
      return filters.sortBy === 'completedFirst' ? aStatus - bStatus : bStatus - aStatus;
    });

    return { ...user, projects: filteredProjects };
  }) // Show use


  console.log(error)



    return (
        <div className=' grow  flex flex-col overflow-auto'>

            <TablePlater className=' flex flex-col gap-2'>
                {/* Buttons section */}
                <div className=' flex justify-start w-full gap-4 max-w-[300px] '>
                    {/* <MultiselectStandard
                        title='Organization'
                        name='organization'

                        onValueChange={(e) => {
                            setFilters({
                                ...filters,
                                organizationIds: e.target.value
                            })
                        }}
                        options={[
                            ...organizations.map(organization => ({
                                label: organization.accountName,
                                value: organization.accountId
                            }))
                        ]}
                        placeholder=''
                        value={filters.organizationIds}
                        maxHeight={100}
                    /> */}
                    {/* <SelectStandard
                        title='Status'
                        name='status'
                        onChange={(e) => {
                            setFilters({
                                ...filters,
                                status: e.target.value as 'completed' | 'inProgress'
                            })
                        }}
                        options={[
                            {
                                label: 'All',
                                value: 'all',
                            },
                            {
                                value: 'inProgress',
                                label: 'In Progress'
                            },
                            {
                                value: 'completed',
                                label: 'Completed'
                            },

                        ]}
                        value={filters.status}
                    /> */}
                    <SelectStandard
                        title='Sort By'
                        name='status'
                        onChange={(e) => {
                            setFilters({
                                ...filters,
                                sortBy: e.target.value as any
                            })
                        }}
                        options={[

                            {
                                value: 'completedFirst',
                                label: 'completed first'
                            },
                            {
                                value: 'uncompletedFirst',
                                label: 'uncompleted first'
                            },
                            {
                                value: 'sortByName',
                                label: 'sort by name'
                            }
                        ]}
                        value={filters.sortBy}
                    />
                    {/* <InputStandard
                        type='date'
                        title='Date'
                        name='date'
                        onChange={(e) => {
                            setFilters({
                                ...filters,
                                date: e.target.value
                            })
                        }}
                        value={filters.date}

                    />
                    <InputStandard
                        type='time'
                        title='Time'
                        name='time'
                        onChange={(e) => {
                            setFilters({
                                ...filters,
                                time: e.target.value
                            })
                        }}
                        value={filters.time}
                    /> */}
                </div>
                {
                    isLoading && (

                        Array.from({ length: 5 }).map((_, i) => (
                            <div key={i} className=' flex items-center justify-center h-20 w-full bg-white shadow-md border animate-pulse '>
                            </div>
                        ))

                    )
                }
                {
                    filteredUsers?.map(user => {
                        return (
                            (
                                <Accordion key={user.user.originId} type="single" collapsible className="w-full">
                                    <AccordionItem value={'item-1'} >
                                        <AccordionTrigger  >
                                            <div className='grid grid-cols-1  w-full md:grid-cols-5 gap-2 gap-y-4'>
                                                <div className='w-full flex items-center gap-2 md:col-span-3 '>
                                                    <div
                                                        style={{
                                                            background: stringToColor(user.user.mailAddress)
                                                        }}
                                                        className="avatar min-h-12 min-w-12 max-h-12 max-w-12 flex items-center justify-center border rounded-full text-white ">
                                                        {user.user.displayName.charAt(0).toUpperCase()}
                                                    </div>
                                                    <div 
                                                        className=' flex flex-col text-start justify-center cursor-pointer hover:text-primary transition-colors'
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            navigate(`/home/master/employee/${user.id?.[0]}`)
                                                        }}
                                                    >
                                                        <TypographyLead>{user.user.displayName}</TypographyLead>
                                                        <TypographyStandardP1 >{user.user.mailAddress}</TypographyStandardP1>
                                                    </div>
                                                </div>
                                                <div className=' flex col-span-1 md:col-span-2'>
                                                    <div className=' flex flex-col w-full place-items-end'>
                                                        <div className='flex'>
                                                            <TypographyStandardTitleH2>Projects: </TypographyStandardTitleH2>
                                                            <TypographyStandardP1>{user.projects.filter(project => project.tasks.length > 0).length}</TypographyStandardP1>
                                                        </div>
                                                        {/* <div className='flex'>
                                                            <TypographyStandardTitleH2>Total Work Item: </TypographyStandardTitleH2>
                                                            <TypographyStandardP1>{user.totalWorkItem}</TypographyStandardP1>
                                                        </div> */}
                                                        <div className='flex'>
                                                            <TypographyStandardTitleH2>Work Items count: </TypographyStandardTitleH2>
                                                            <TypographyStandardP1>{user.projects.reduce((total, project) => total + project.tasks.length, 0)}</TypographyStandardP1>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </AccordionTrigger>
                                        <AccordionContent>
                                            <div className=' flex flex-col gap-1'>
                                                {user.projects.filter(project => project.tasks.length > 0).map(
                                                    project => {
                                                        return (
                                                            <ProjectComponentTaskVarient
                                                                // TotalWorkItem={project.userTotalWorkItems}
                                                                // completedWorkItem={project.userCompletedWorkItems}
                                                                key={project.id}
                                                                organization={project.organisationName}
                                                                projectName={project.name}
                                                                tasks={project.tasks}
                                                            />
                                                        )
                                                    }
                                                )}
                                            </div>
                                        </AccordionContent>
                                    </AccordionItem>
                                </Accordion>
                            )
                        )
                    })
                }


            </TablePlater>
        </div>
    )

}



